module.exports = {
  market: 'en-CA',
  realm: 'CA',
  domain: 'weightwatchers.ca',
  countryId: '2000',
  vsPath: 'ca/en',
  spiceLocale: 'ca',
  vsUrl: 'https://www{env}weightwatchers.com/ca/en',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/ca/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.ca/',
  currency: 'C $',
  decimalSeparator: '.',
  thousandSeparator: ',',
  currencyFormat: 'C $%number',
  useZipCodeForEligibleOffers: true,
  dateFormat: 'MM/dd/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.ca/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.ca/v2/login/',
  countryCode: 'CA',
  commUlr: 'https://commerce{env}weightwatchers.com/ca/en/api/',
  timezone1: 'America/Toronto',
  timezone2: '-05:00',
};
